import React from 'react';
import { Modal } from 'react-bootstrap';
import Draggable from 'react-draggable';
class DraggableModalDialog extends React.Component {
    render() {
        const { className, children, ...modalProps } = this.props;
        return (
            <Draggable handle='.modal-header'>
                <div className={className}>
                    <Modal.Dialog {...modalProps}>{children}</Modal.Dialog>
                </div>
            </Draggable>
        );
    }
}
class DraggableModal extends React.Component {
    render() {
        const { className, children, ...rest } = this.props;
        return (
            <Modal
                {...rest}
                dialogAs={DraggableModalDialog}
                className={`draggable-modal ${className || ''}`}
            >
                {children}
            </Modal>
        );
    }
}
export default DraggableModal;
